import { defineMessages } from 'react-intl';

export default defineMessages({
    activitieslandingAssignment: {
        id: 'ad.gateway.views.activities-landing.Assignment',
        defaultMessage: 'Assignment',
    },
    activitieslandingComplete: {
        id: 'ad.gateway.views.activities-landing.Complete',
        defaultMessage: 'Complete',
    },
    activitieslandingCanceled: {
        id: 'ad.gateway.views.activities-landing.Canceled',
        defaultMessage: 'Canceled',
    },
    activitieslandingCreatedBy: {
        id: 'ad.gateway.views.activities-landing.Created By',
        defaultMessage: 'Created By',
    },
    activitieslandingLoadingActivities: {
        id: 'ad.gateway.views.activities-landing.Loading Activities',
        defaultMessage: 'Loading Activities',
    },
    activitieslandingMe: {
        id: 'ad.gateway.views.activities-landing.Me',
        defaultMessage: 'Me',
    },
    activitieslandingOpen: {
        id: 'ad.gateway.views.activities-landing.Open',
        defaultMessage: 'Open',
    },
    activitieslandingOptions: {
        id: 'ad.gateway.views.activities-landing.Options',
        defaultMessage: 'Options',
    },
    activitieslandingOthers: {
        id: 'ad.gateway.views.activities-landing.Others',
        defaultMessage: 'Others',
    },
    activitieslandingPriority: {
        id: 'ad.gateway.views.activities-landing.Priority',
        defaultMessage: 'Priority',
    },
    activitieslandingQuickFilters: {
        id: 'ad.gateway.views.activities-landing.Quick Filters',
        defaultMessage: 'Quick Filters',
    },
    activitieslandingSkipped: {
        id: 'ad.gateway.views.activities-landing.Skipped',
        defaultMessage: 'Skipped',
    },
    activitieslandingUnassigned: {
        id: 'ad.gateway.views.activities-landing.Unassigned',
        defaultMessage: 'Unassigned',
    },
    activitieslandingStatus: {
        id: 'ad.gateway.views.activities-landing.Status',
        defaultMessage: 'Status',
    },
    activitieslandingSwitchto: {
        id: 'ad.gateway.views.activities-landing.Switch to',
        defaultMessage: 'Switch to',
    },
    activitieslandingToMe: {
        id: 'ad.gateway.views.activities-landing.To Me',
        defaultMessage: 'To Me',
    },
    activitieslandingToOthers: {
        id: 'ad.gateway.views.activities-landing.To Others',
        defaultMessage: 'To Others',
    },
    activitieslandingType: {
        id: 'ad.gateway.views.activities-landing.Type',
        defaultMessage: 'Type',
    },
    activitieslandingClearAll: {
        id: 'ad.gateway.views.filters.Clear All',
        defaultMessage: 'Clear All',
    },
    activitieslandingClearAllFilters: {
        id: 'ad.gateway.views.filters.Clear All Filters',
        defaultMessage: 'Clear All Filters',
    },
    activitieslandingSelectAll: {
        id: 'ad.gateway.views.filters.Select All',
        defaultMessage: 'Select All',
    },
});
